import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../../utils/localStorage";
import { ProgressSpinner } from "primereact/progressspinner";
import { getPaymentGatewayConfig, getStorePaymentGatewayConfig } from "../../../../services/PaymentGatewayConfig/PaymentGatewayConfig";
import StorePaymentGatewayAddModal from "./StorePaymentGatewayAddModal";
import StoreStorePaymentGatewayStatusChange from "./StoreStorePaymentGatewayStatusChange";
import AdminMenu from "../../../AdminMenu";
import ActiveInActiveFilter from "../ActiveInActiveFilter";


const StoreConfigPaymentGatewayView = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id ,StoreData} = location.state || {}; // Fallback to prevent undefined errors

  const [visible, setVisible] = useState(false);
  const [paymentGatewayData, setPaymentGatewayData] = useState([]);
  const [paymentGatewayDataAll, setPaymentGatewayDataAll] = useState([]);
  const [paymentGatewayConfigData, setPaymentGatewayConfigData] = useState([]);
  const [paymentGatewayModalVisible, setPaymentGatewayModalVisible] =
    useState('');
  const [loading, setLoading] = useState(false);

  const [activeInActiveFilterVisible, setActiveInActiveFilterVisible] =
      useState(false);
  

  const { brandProfileData , userProfileRole} = getUserData();
  let brandId = brandProfileData.id;
  let userRole = userProfileRole;
  const fetchOffers = () => {
    setLoading(true);
    getStorePaymentGatewayConfig(id)
      .then(response => {
        if (!response.data.error) {
          const res = response.data;
          setPaymentGatewayDataAll(res);
          const NewRes = res.filter((item) => item.status === true);
          setPaymentGatewayData(NewRes);
          setLoading(false);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });

    getPaymentGatewayConfig(brandId)
      .then(response => {
        if (!response.data.error) {
          const res = response.data;
          setPaymentGatewayConfigData(res);
          setLoading(false);
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
  };
  useEffect(() => {
    fetchOffers();
  }, []);

  const receiveDataFromActiveInActiveFilter = (selectedValue) => {
    const newMap = paymentGatewayDataAll?.filter((service) =>
      selectedValue?.some((item) => item.value === service?.status),
    );
    setPaymentGatewayData(newMap);
  };

  const receiveDataFromStatusChange = ({success}) => {
    if (success) {
      fetchOffers();
    }
  };
  const renderOfferCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div key={item.id}>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Gateway Name :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.brandPaymentGatewayInfo.gatewayName}
                  </p>
                </div>

                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Status
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.status === true ? "Active" : "InActive"}{" "}
                    </p>
                  </div>
                  {item.brandPaymentGatewayInfo.status === "ACTIVE" && (
                    <div>
                      {userRole === "BY_FRANCHISE_ADMIN" ? (
                        ""
                      ) : (
                        <StoreStorePaymentGatewayStatusChange
                          status={item.status}
                          sendDataToStoreConfig={receiveDataFromStatusChange}
                          editData={item}
                          storeId={id}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() =>
                    navigate("/StoreConfigList", {
                      state: {
                        id: id,
                        StoreData: StoreData,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Store Payment Gateway
              </p>
            </div>
          </div>
          <div
            onClick={() => setActiveInActiveFilterVisible(true)}
            className="flex justify-content-center align-items-center mx-2 cursor-pointer"
          >
            <div>
              <img
                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                style={{ width: 27 }}
              />
            </div>
          </div>
          {userRole === "BY_FRANCHISE_ADMIN" ? (
            ""
          ) : (
            <div
              className="flex justify-content-center align-items-center cursor-pointer mr-4"
              onClick={() => setPaymentGatewayModalVisible(true)}
            >
              <img src="images/plus.png" alt="plus" style={{ width: 30 }} />
            </div>
          )}
          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : paymentGatewayData?.length > 0 ? (
          <div>
            <div>{renderOfferCardItem(paymentGatewayData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Data Present</p>
          </div>
        )}
      </div>
      <StorePaymentGatewayAddModal
        paymentGatewayModalVisible={paymentGatewayModalVisible}
        setPaymentGatewayModalVisible={setPaymentGatewayModalVisible}
        sendDataToStoreConfig={receiveDataFromStatusChange}
        paymentGatewayConfigData={paymentGatewayConfigData}
        brandId={brandId}
        storeId={id}
        paymentGatewayData={paymentGatewayData}
      />
<ActiveInActiveFilter
        setActiveInActiveFilterVisible={setActiveInActiveFilterVisible}
        activeInActiveFilterVisible={activeInActiveFilterVisible}
        sendDataToActiveInActiveFilter={receiveDataFromActiveInActiveFilter}
      />
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default StoreConfigPaymentGatewayView;
